export default "__VITE_ASSET__f1ec9afa__"